import AppLinkComponent, { AppLinkProps } from "@/components/AppLink";
import { Button as ButtonStyled } from "../styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const AppLink = AppLinkComponent as any;
const Button = ButtonStyled as any;

export type InternalLinkProps = AppLinkProps & {
  title: string;
};

const InternalLink: React.FC<InternalLinkProps> = (props) => {
  const { title, page, params } = props;
  return (
    <AppLink page={page} params={params}>
      <Button>{title}</Button>
    </AppLink>
  );
};

export default InternalLink;
